export const ruTranslations = {
  landing: {
    title:
      "Grensa.AI – Искусственный интеллект для сотрудников поддержки и продаж",
  },
  navigation: {
    about: "О виджете",
    quickstart: "Легкий старт",
    benefits: "Преимущества",
    pricing: "Тарифы",
  },
  buttons: {
    try: "Попробовать",
    demoCall: "Демо звонок",
  },
  top: {
    title: "Искусственный интеллект для сотрудников поддержки и продаж",
    caption:
      "Интеграция за 2 минуты. Grensa.AI встраивается в ваш хелпдеск, помогает находить ответы быстрее, соблюдать SLA и работать эффективнее без лишних усилий.",
  },
  solutions: {
    title: "С чем мы можем помочь?",
    solutionText: [
      {
        title: "Запросов много, времени мало",
        caption:
          "Grensa.AI анализирует базу знаний и предлагает готовые ответы прямо в чате. Менеджер просто выбирает нужный вариант",
      },
      {
        title: "Менеджеры теряют контекст переписки",
        caption:
          "ИИ делает краткое саммари, чтобы менеджер сразу понял, о чем речь, без лишнего перечитывания",
      },
      {
        title: "Просроченные заявки и нарушение SLA",
        caption:
          "Напоминает какие заявки требуют срочного ответа, чтобы SLA не нарушался",
      },
      {
        title: "Разный стиль общения и ошибки в текстах",
        caption:
          "ИИ проверяет тональность и корректность ответов, выделяет ошибки и предлагает улучшения",
      },
      {
        title: "Долгое обучение новым инструментам",
        caption:
          "Интеграция занимает 2 мин. — установите расширение и вставьте ссылку на базу знаний",
      },
    ],
  },
  howToStart: {
    title: "Как начать работу?",
    caption: "Grensa.AI подключается за 2 минуты",
    installTry: "Установить и попробовать",
    steps: [
      { title: "Установите расширение", description: "" },
      { title: "Добавьте ссылку на базу знаний", description: "" },
      {
        title: "Отправьте ссылку коллегам",
        description: "Они подключатся автоматически",
      },
      { title: "Готово!", description: "" },
    ],
  },
  reasons: {
    title: "Почему это вам нужно?",
    caption: "Что меняется с Grensa.AI?",
    reasonText: [
      {
        title: "Ответы быстрее на 50%",
        caption: "AI сокращает время на поиск и формулировку",
      },
      {
        title: "Меньше ошибок и опечаток",
        caption: "AI помогает соблюдать стиль и корректность",
      },
      {
        title: "Контроль SLA",
        caption: "Напоминания не дадут пропустить важные заявки",
      },
      {
        title: "Простая установка",
        caption: "Не требует IT-ресурсов и сложных настроек",
      },
    ],
  },
  pricing: {
    title: "Тарифы",
    try: "Попробовать",
    options: [
      {
        name: "Personal",
        price1: "Бесплатно",
        perks: ["X рекомендацией сообщений", "Контекст диалога", "1 аккаунт"],
      },
      {
        name: "Pro Plan",
        price1: "4 руб.",
        price2: "/ тикет",
        perks: [
          "Рекомендации ответов",
          "Контекст диалога",
          "Контроль SLA",
          "Контроль TOV и качества",
          "До 20 аккаунтов",
        ],
      },
      {
        name: "Enterprise",
        price1: "Индивидуально",
        perks: [
          "Безлимит рекомендацией сообщений",
          "Контекст диалога",
          "Контроль TOV и качества",
          "Х сотрудников",
        ],
      },
    ],
  },
  footer: {
    title: "Установите Grensa.AI и ускорьте свою команду!",
    caption: "Попробуйте бесплатно – настройка займет не больше 2 минут.",
    tryFree: "Попробовать бесплатно",
  },
  demo: {
    title: "Обратный звонок",
    namePlaceholder: "Имя",
    nameLabel: "Представьтесь",
    phoneLabel: "Номер телефона",
    submitButton: "Отправить",
    errorMessageRequired: "Обязательное Поле",
    success: {
      title: "Заявка успешно отправлена!",
      caption: "Мы скоро свяжемся с вами",
      done: "Готово",
    },
  },
};
